import CT from '@marketplace-ai/tags';
import { createElement, type ComponentProps } from 'react';
import { ContactInformationView } from './contactForm/ContactInformationView';
import { PersonalInfoForm } from './PersonalInfoForm';
import { ProfessionalInformationForm } from './ProfessionalInformationForm';
import { SensitiveInformationForm } from './SensitiveInformationForm';

const renderPersonalForm = (props: ComponentProps<typeof PersonalInfoForm>) =>
  createElement(PersonalInfoForm, props);
const renderSensitiveForm = (props: ComponentProps<typeof SensitiveInformationForm>) =>
  createElement(SensitiveInformationForm, props);
const renderProfessionalForm = (props: ComponentProps<typeof ProfessionalInformationForm>) =>
  createElement(ProfessionalInformationForm, props);
const renderContactForm = (props: ComponentProps<typeof ContactInformationView>) =>
  createElement(ContactInformationView, props);

// Keep the component registry separate from field-option constants. The form
// components consume those constants themselves, so colocating this registry
// there created a module cycle that made isolated form rendering unreliable.
export const PROFILE_TABS = [
  {
    name: 'Personal Information',
    current: true,
    form: renderPersonalForm,
    cyTag: CT.profile.tabs.personalInfoTab,
  },
  {
    name: 'Sensitive Information',
    current: false,
    form: renderSensitiveForm,
    cyTag: CT.profile.tabs.sensitiveInfoTab,
  },
  {
    name: 'Professional Information',
    current: false,
    form: renderProfessionalForm,
    cyTag: CT.profile.tabs.professionalInfoTab,
  },
  {
    name: 'Contact Information',
    current: false,
    form: renderContactForm,
    cyTag: CT.profile.tabs.contactInfoTab,
  },
];
